<script setup>
defineProps({
    notification: { type: Object, required: true },
    read: { type: Boolean, default: false },
})

defineEmits(['delete', 'accept', 'deny'])
</script>

<template>
    <div class="tw:focus-within:outline-2 tw:focus-within:outline-[#0033FF]">
        <component
            :is="notification.link ? 'a' : 'div'"
            :href="notification.link || undefined"
            class="tw:group/item tw:flex tw:items-center tw:gap-3 tw:px-3 tw:py-2 tw:rounded-sm tw:no-underline tw:hover:no-underline tw:focus:no-underline tw:active:no-underline tw:hover:bg-cloud-cover-200 tw:active:bg-caribe-200"
            :class="notification.link ? 'tw:cursor-pointer' : ''"
        >
            <!-- Status dot -->
            <span
                class="tw:size-2.5 tw:rounded-full tw:shrink-0"
                :class="read ? 'tw:bg-cloud-cover-500' : 'tw:bg-chili-red-500'"
            ></span>

            <!-- Content -->
            <div class="tw:flex tw:flex-1 tw:flex-col tw:gap-2 tw:min-w-0">
                <div class="tw:flex tw:items-center tw:w-full">
                    <p
                        class="tw:flex-1 tw:text-base tw:font-medium tw:leading-5 tw:m-0 tw:group-active/item:text-caribe-500"
                        :class="read ? 'tw:text-cloud-cover-500' : 'tw:text-cloud-cover-800'"
                    >
                        {{ notification.text }}
                    </p>
                    <div
                        v-if="notification.requires_action"
                        class="tw:flex tw:items-center tw:gap-1 tw:ml-2 tw:shrink-0"
                    >
                        <button
                            class="tw:p-1 tw:bg-transparent tw:border-none tw:cursor-pointer tw:text-cloud-cover-800 tw:hover:text-caribe-500"
                            @click.stop.prevent="$emit('accept', notification)"
                        >
                            <span class="material-symbols-outlined" style="font-size: 18px">check</span>
                        </button>
                        <button
                            class="tw:p-1 tw:bg-transparent tw:border-none tw:cursor-pointer tw:text-cloud-cover-800 tw:hover:text-dark-raspberry-500"
                            @click.stop.prevent="$emit('deny', notification)"
                        >
                            <span class="material-symbols-outlined" style="font-size: 18px">block</span>
                        </button>
                    </div>
                </div>
                <p
                    class="tw:text-[10px] tw:leading-3.25 tw:text-neutral-500 tw:m-0 tw:group-active/item:text-caribe-500"
                >
                    {{ notification.created_at }}
                </p>
            </div>

            <!-- Delete button -->
            <button
                class="tw:flex tw:items-center tw:justify-center tw:size-9 tw:p-2 tw:rounded tw:bg-transparent tw:border-none tw:cursor-pointer tw:text-cloud-cover-800 tw:shrink-0 tw:hover:text-caribe-500 tw:group/del"
                @click.stop.prevent="$emit('delete', notification)"
            >
                <span
                    class="material-symbols-outlined tw:group-hover/del:[font-variation-settings:'FILL'_1]"
                    style="font-size: 20px"
                    >delete</span
                >
            </button>
        </component>
    </div>
</template>
